import { vars } from '@etg/wings';
import { css } from '@eti/styles';
import type { ReactNode } from 'react';

interface CFCImportantNoteProps {
  content: ReactNode;
}

const cfcImportantNoteStyles = css`
  background: #fafafa;
  border-left: 4px solid ${vars.colors.signal.caution.light};
  padding: 8px;
`;

const CFCImportantNote = ({ content }: CFCImportantNoteProps) => {
  return (
    <div className={cfcImportantNoteStyles} data-testid="cfc-important-notification">
      {content}
    </div>
  );
};

export default CFCImportantNote;
